import { buildCartServiceFromVariant } from "./serviceVariants";

export function getServiceCatalogPrice(item: any): number {
  const n = Number(
    item?.price_from ?? item?.lst_price ?? item?.variants?.[0]?.lst_price
  );
  return Number.isFinite(n) ? n : 0;
}

export function getServiceCatalogDiscount(item: any): number {
  const n = Number(
    item?.lst_price_discount ?? item?.variants?.[0]?.lst_price_discount
  );
  return Number.isFinite(n) ? n : 0;
}

export function getServiceWorkHours(item: any): number {
  const n = Number(
    item?.work_hours ??
      item?.expected_duration ??
      item?.variants?.[0]?.work_hours
  );
  return Number.isFinite(n) ? n : 0;
}

export function hasServiceVariants(item: any): boolean {
  const count = Number(item?.variant_count);
  if (Number.isFinite(count) && count > 1) return true;
  return Array.isArray(item?.variants) && item.variants.length > 1;
}

export function normalizeServiceListItem(item: any) {
  const price = getServiceCatalogPrice(item);
  const discount = getServiceCatalogDiscount(item);
  const workHours = getServiceWorkHours(item);

  return {
    ...item,
    price_from: item?.price_from ?? price,
    lst_price: price,
    lst_price_discount: discount > 0 ? discount : price,
    work_hours: workHours,
    expected_duration: workHours,
  };
}

export function normalizeServiceDetailItem(item: any) {
  if (!item || typeof item !== "object") return item;
  return normalizeServiceListItem(item);
}

export function resolveServiceCartPayload(item: any) {
  if (!item) return null;
  if (hasServiceVariants(item)) return null;

  const variant = Array.isArray(item?.variants) ? item.variants[0] : null;
  if (variant) {
    return buildCartServiceFromVariant(item, {
      ...variant,
      work_hours: getServiceWorkHours(variant),
      expected_duration: getServiceWorkHours(variant),
    });
  }

  return normalizeServiceListItem(item);
}

export function getServiceFilterPrice(item: any): number {
  return getServiceCatalogPrice(item);
}
